import { useEffect, useState } from 'react';
import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';
import { TAPIResponse } from '../../api.types';

export type TAPICountryDetails = {
  country_name: string;
  country_code_iso2: string;
  isd_code: string;
  id: string;
};

export type TAPIHookFetchCountryDetailsResponse = Omit<TAPIResponse, 'data'> & {
  data: TAPICountryDetails[];
  fetchCountryDetails(): Promise<TAPICountryDetails[]>;
};

export type TAPIHookFetchCountryDeatilsOptions = {
  silence?: boolean;
};

export const useAPIFetchCountryDetails = (
  options?: TAPIHookFetchCountryDeatilsOptions
): TAPIHookFetchCountryDetailsResponse => {
  const [responseData, setResponseData] = useState<TAPICountryDetails[]>([]);
  const { get, response, loading, error } = useFetch(API_ROUTES.COMMON);

  async function fetchCountryDetails(): Promise<TAPICountryDetails[]> {
    const { data } = await get(`/countrydetails`);

    if (response.ok) {
      setResponseData(data.items);
    }

    return Promise.resolve(data?.items || []);
  }

  useEffect(() => {
    !options?.silence && fetchCountryDetails();
  }, []);

  return {
    loading,
    error,
    data: responseData,
    loaded: response.ok,
    fetchCountryDetails,
  };
};
